/** @file directionLabel: a body azimuth as a compass label (0 S, 90 W, 180 N, 270 E, diagonals) or degrees. */
import { wrapDegrees } from '@zilo/pose3d-std/math/wrapDegrees';

const NAMES: Record<number, string> = { 0: 'S', 45: 'SW', 90: 'W', 135: 'NW', 180: 'N', 225: 'NE', 270: 'E', 315: 'SE' };

/** `S`, `SW`, `W`, `NW`, `N`, `NE`, `E`, `SE` on the eight compass azimuths, else the degrees (`22.5°`); `?` when unknown. */
export function directionLabel(bodyAzimuthDeg: number | undefined): string {
  if (bodyAzimuthDeg === undefined || !Number.isFinite(bodyAzimuthDeg)) return '?';
  const deg = Math.round(wrapDegrees(bodyAzimuthDeg) * 10) / 10;
  return NAMES[deg === 360 ? 0 : deg] ?? `${deg}°`;
}
